<template>
    <nav class="top-menu d-sm-flex flex-column align-items-start" :class="{'top-menu-fixed': isFixed}">
        <div class="">
            <div class="menu-selection d-none d-sm-flex flex-row" @click.prevent="!isStatic && toggleMenu()" :class="{'cursor-pointer': !isStatic}">
                <div class="menu-icon d-flex align-items-center mr-3" v-if="!isStatic">
                    <img alt="Menu" :src="[showModulesMenu ? menuCloseIcon : menuIcon]">
                </div>
                <div class="menu-title">
                    <h1>{{ currentModuleName }}</h1>
                </div>
            </div>
            <div class="menu-modules" :class="{'menu-open': showModulesMenu}">
                <div class="menu-icon d-flex d-md-none align-items-center mr-3 mt-3" @click.prevent="toggleTopMenu()">
                    <img alt="Menu" :src="menuCloseIcon">
                </div>
                <ul class="menu-list d-flex flex-wrap pt-sm-3">
                    <li v-for="(item, idx) in sortedModules" :key="`module-${idx}`" class="">
                        <template v-if="item.route">
                            <router-link
                                :class="{ 'active': currentApplicationCode == item.code}"
                                :to="{
                                    name: item.route,
                                    params: {
                                        code: item.code,
                                        appCode: formatRouteAppCode(item.code),
                                        title: item.name
                                    }
                                }">
                                {{ item.name }}
                            </router-link>
                        </template>
                        <template v-else-if="item.url">
                            <a :href="item.url" target="_blank" @click="toggleMenu">
                                {{ item.name }}
                            </a>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import { CheckPermission } from '../../mixins/acls';
    import { formatRouteAppCode } from '@config/utils';
    import MenuIcon from '@images/icons/menu-bars.svg';
    import MenuCloseIcon from '@images/icons/menu-bars-close.svg';

    export default {
        mixins: [CheckPermission],
        props: {
            moduleCode: {
                type: String,
                required: true,
                default: null,
            },
            isStatic: {
                type: Boolean,
                default: false,
            },
            isFixed: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                showModulesMenu: false,
            }
        },
        computed: {
            menuIcon() {
                return MenuIcon;
            },
            menuCloseIcon() {
                return MenuCloseIcon;
            },
            currentRouteName() {
                return this.$route.name;
            },
            currentApplicationCode() {
                return this.$store.getters.applicationCode ?? '';
            },
            currentModuleCode() {
                return this.$store.getters.moduleCode;
            },
            currentModuleName() {
                return this.$store.getters.moduleName;
            },
            modules(){
                let modules = this.moduleCode ? this.$store.getters.getModules(this.moduleCode) : [];
                return modules.filter( m => {
                    return m.active && this.checkPermission(m, 'acl');
                });
            },
            sortedModules() {
                return this.modules.sort((a, b) => {
                    const compareCurrent = (a,b) => (a.code == this.currentApplicationCode ? -3 : 0) - (b.code == this.currentApplicationCode? -3:0);
                    const compareOrder = (a,b) => a.order<b.order? -1 : b.order<a.order? 1:0;
                    const compareIsBackoffice = (a,b) => !!a.backoffice-!!b.backoffice;
                    const compareName = (a,b) => a.name<b.name? -1 : b.name<a.name? 1:0;
                    return compareCurrent(a,b) || compareOrder || compareIsBackoffice(a,b) || compareName(a,b);
                });
            },
        },
        methods: {
            formatRouteAppCode(code) {
                return formatRouteAppCode(code);
            },
            toggleMenu: function() {
                if (this.modules.length>0){
                    this.showModulesMenu = !this.showModulesMenu;
                }
            },
            toggleTopMenu: function() {
                this.$emit('toggleClick');
            },
        }
    }
</script>

<style scoped lang="scss">
@import "@styles/bootstrap/_mixins.scss";
@import "@styles/_mixins.scss";
@import '@styles/_theme.scss';

.top-menu {
    display: inline-block;
    background: $top-menu-dashboard-bg-color;
    color: $top-menu-dashboard-color;
    /* z-index: $zindex-content-sidebar+1; */

    .menu-selection {
        font-size: $top-menu-dashboard-selection-font-size;
        font-family: $top-menu-dashboard-selection-font;
        text-transform: $top-menu-dashboard-selection-text-transform;
        padding: 0.625rem 0 0.625rem 2.5rem;
        .menu-title h1 {
            font-size: inherit;
            padding: 0;
            font-weight: inherit;
            margin: 0;
            font-family: inherit;
            text-transform: inherit;
            line-height: inherit;
        }
    }

    .menu-modules {
        z-index: $zindex-content-sidebar+2;
        background: $top-menu-dashboard-bg-color;
        position: absolute;
        overflow: hidden;
        max-height: 0;
        width: 100%;
        margin: 0;
        padding: 0;
        padding-left: 2.5rem + 2rem + 1rem;
        -moz-transition: max-height 1s ease-out;
        -ms-transition: max-height 1s ease-out;
        -o-transition: max-height 1s ease-out;
        -webkit-transition: max-height 1s ease-out;
        transition: max-height 1s ease-out;

        &.menu-open {
            max-height: 500px;
            -moz-transition: max-height 1s ease-out;
            -ms-transition: max-height 1s ease-out;
            -o-transition: max-height 1s ease-out;
            -webkit-transition: max-height 1s ease-out;
            transition: max-height 1s ease-out;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style-type: none;
            transition-delay: 1s;
            font-weight: 500;

            li {
                margin-bottom: 0.9rem;
                @include sm {
                    margin-right: 3rem;
                    margin-bottom: 1.3rem;
                }

                a {
                    color: $top-menu-dashboard-color;
                    font-size: 16px;
                    @include sm {
                        font-size: $top-menu-dashboard-modules-font-size;
                    }
                    font-family: $top-menu-dashboard-modules-font;
                    text-transform: $top-menu-dashboard-modules-text-transform;

                    &:hover {
                        font-weight: bolder;
                    }

                    &.active {
                        font-family: $top-menu-dashboard-modules-active-font;
                    }
                }
            }
        }
    }

    .menu-icon {
        cursor: pointer;
    }

}

@include media-breakpoint-down(sm) {
    .top-menu {
        &::before {
            transition: opacity 1s ease-out;
            position: fixed;
            display: block;
            content: '';
            top: 0;
            left: -100%;
            right: 100%;
            bottom: 0;
            opacity: 0;
            background: rgba(0,0,0,0.1);
            z-index: $zindex-content-sidebar+1;
        }

        .menu-modules,
        .menu-modules.menu-open {
            transition: left 1s ease-out;
            height: 100vh;
            max-height: 100vh;
            top: 0;
            padding-left: 1rem;
            padding-right: 1rem;
            /* max-width: 415px; */
            left: -100%;
            ul {
                flex-direction: column;
                padding: 30px 0;
            }
        }
    }

    .ct-aside-on .top-menu{
        &::before {
            left: 0%;
            right: 0%;
            opacity: 1;
        }
        .menu-modules {
            left: 0;
        }

    }
}
</style>

<style lang="scss">
@import '@styles/_theme.scss';
@import '@styles/_mixins.scss';

@include sm {
    .top-menu {
        &.top-menu-fixed {
            position: fixed;
            right: 0;
            left: 0;
            z-index: $zindex-main-header - 1;

            &+ .ct-content {
                margin-top: 59px; // FIX
            }
        }
    }

}
</style>
